import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadingService } from '../services/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent implements OnInit, OnDestroy {

  visible = false;
  isFinished = false;
  private subscription!: Subscription;

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.subscription = this.loadingService.loading$.subscribe((loading) => {
      if (loading) {
        this.visible = true;
        this.isFinished = false;
      } else {
        if (this.visible) {
          this.isFinished = true;
          setTimeout(() => {
            this.visible = false;
            this.isFinished = false;
          }, 400); // 400ms allows the progress bar to complete (100%) and the overlay to fade out
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
